module.exports = __webpack_public_path__ + "static/media/Section1Img.3a649174.png";